
import { Product } from '@/modules/product/models/product.interface';
import { formatDate } from '@/plugins/filters';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'ProductList',
  emits: ['try-it'],
  props: {
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
  },
  computed: {
    createdDate() {
      return formatDate(this.product.createdDate);
    },
  },
  methods: {
    tryIt(): void {
      this.$emit('try-it', this.product.importedFrom);
    },
  },
});
